// ============================================================
// BANK SOAL KECERMATAN — PSIKOTES TNI SIMULASI
// Versi 1.0 | Sumber: PDF NNC-2 + Tes Angka 05 + soal generate
// ============================================================

function svgWrap(content, bg = '#F8FAFC') {
  return `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><rect width="100" height="100" fill="${bg}" rx="6"/>${content}</svg>`;
}

// ------------------------------------------------------------
// SUB-MODUL 1: NNC-2
// Format: bandingkan 3 kolom, pilih jawaban:
//   a = semua sama
//   b = hanya kolom 1 & 2 sama
//   c = hanya kolom 1 & 3 sama
//   d = hanya kolom 2 & 3 sama
//   e = tidak ada yang sama
// ------------------------------------------------------------

export const soalNNC2 = [
  // === DARI PDF NNC-2 (soal 1-30) ===
  {
    id: "NNC-001",
    kolom1: "1770432",
    kolom2: "1770423",
    kolom3: "1770432",
    jawaban: "c",
    sumber: "PDF"
  },
  {
    id: "NNC-002",
    kolom1: "Narm Djalil",
    kolom2: "Narm Jalil",
    kolom3: "Narm Djalil",
    jawaban: "c",
    sumber: "PDF"
  },
  {
    id: "NNC-003",
    kolom1: "2342759",
    kolom2: "2342759",
    kolom3: "2342759",
    jawaban: "a",
    sumber: "PDF"
  },
  {
    id: "NNC-004",
    kolom1: "7104748",
    kolom2: "7104748",
    kolom3: "7104747",
    jawaban: "b",
    sumber: "PDF"
  },
  {
    id: "NNC-005",
    kolom1: "Chotimatul Syaidha",
    kolom2: "Khotimatul Syaidha",
    kolom3: "Khotimatul Syaidha",
    jawaban: "d",
    sumber: "PDF"
  },
  {
    id: "NNC-006",
    kolom1: "Muhammad Nuzlan",
    kolom2: "Muhamad Nuzlan",
    kolom3: "Muhammat Nuzlan",
    jawaban: "e",
    sumber: "PDF"
  },
  {
    id: "NNC-007",
    kolom1: "1A7Z8BYA4",
    kolom2: "1A7Z8BYA4",
    kolom3: "1A7Z8BYA4",
    jawaban: "a",
    sumber: "PDF"
  },
  {
    id: "NNC-008",
    kolom1: "9gaMWET?",
    kolom2: "GgaMWET?",
    kolom3: "9gaMW3T?",
    jawaban: "e",
    sumber: "PDF"
  },
  {
    id: "NNC-009",
    kolom1: "David Gurnita",
    kolom2: "Davit Gurnita",
    kolom3: "David Gurmita",
    jawaban: "e",
    sumber: "PDF"
  },
  {
    id: "NNC-010",
    kolom1: "G9OGON",
    kolom2: "G9OGON",
    kolom3: "G9O9ON",
    jawaban: "b",
    sumber: "PDF"
  },
  {
    id: "NNC-011",
    kolom1: "Miftaiah Faiqoh",
    kolom2: "Miftaiah Faiqoh",
    kolom3: "Miftaiah Faigoh",
    jawaban: "b",
    sumber: "PDF"
  },
  {
    id: "NNC-012",
    kolom1: "342679765",
    kolom2: "342679765",
    kolom3: "342679765",
    jawaban: "a",
    sumber: "PDF"
  },
  {
    id: "NNC-013",
    kolom1: "6789100875",
    kolom2: "6789100875",
    kolom3: "6789100875",
    jawaban: "a",
    sumber: "PDF"
  },
  {
    id: "NNC-014",
    kolom1: "Megan Andanna",
    kolom2: "Meqan Andanna",
    kolom3: "Megan Andana",
    jawaban: "e",
    sumber: "PDF"
  },
  {
    id: "NNC-015",
    kolom1: "Asmarul Qusnah",
    kolom2: "Asmarul Kusnah",
    kolom3: "Asmaul Qusnah",
    jawaban: "e",
    sumber: "PDF"
  },
  {
    id: "NNC-016",
    kolom1: "Jihan Fahirah",
    kolom2: "Jihan Fahirah",
    kolom3: "Jihan Fahira",
    jawaban: "b",
    sumber: "PDF"
  },
  {
    id: "NNC-017",
    kolom1: "1256347810",
    kolom2: "1256347810",
    kolom3: "1256347810",
    jawaban: "a",
    sumber: "PDF"
  },
  {
    id: "NNC-018",
    kolom1: "77654321024",
    kolom2: "77654321024",
    kolom3: "77654E21024",
    jawaban: "b",
    sumber: "PDF"
  },
  {
    id: "NNC-019",
    kolom1: "56645325655",
    kolom2: "5G645325655",
    kolom3: "56645325655",
    jawaban: "c",
    sumber: "PDF"
  },
  {
    id: "NNC-020",
    kolom1: "G99TUJ56G",
    kolom2: "G99TUJ56G",
    kolom3: "G99TUJ56G",
    jawaban: "a",
    sumber: "PDF"
  },
  {
    id: "NNC-021",
    kolom1: "Vinetta Khonilo",
    kolom2: "Ninetta Qonilo",
    kolom3: "Vinetta Khonilo",
    jawaban: "c",
    sumber: "PDF"
  },
  {
    id: "NNC-022",
    kolom1: "R120SA12INA",
    kolom2: "R120SA12INA",
    kolom3: "R1205A12INA",
    jawaban: "b",
    sumber: "PDF"
  },
  {
    id: "NNC-023",
    kolom1: "325467821",
    kolom2: "325467821",
    kolom3: "325467821",
    jawaban: "a",
    sumber: "PDF"
  },
  {
    id: "NNC-024",
    kolom1: "Emile Marie Dobes",
    kolom2: "Emire Marie Dobes",
    kolom3: "Emile Marie Dobes",
    jawaban: "c",
    sumber: "PDF"
  },
  {
    id: "NNC-025",
    kolom1: "Munira salvoenela",
    kolom2: "Munira salvonela",
    kolom3: "Munira salvunela",
    jawaban: "e",
    sumber: "PDF"
  },
  {
    id: "NNC-026",
    kolom1: "Irene Maria Gores",
    kolom2: "Irene Maria Gores",
    kolom3: "Irene Maria Bores",
    jawaban: "b",
    sumber: "PDF"
  },
  {
    id: "NNC-027",
    kolom1: "12AB34CDE3",
    kolom2: "12AB34CDE3",
    kolom3: "12AB34CDE3",
    jawaban: "a",
    sumber: "PDF"
  },
  {
    id: "NNC-028",
    kolom1: "D412MA Agoesta",
    kolom2: "DARMA A9oesta",
    kolom3: "DARMA Agoesta",
    jawaban: "e",
    sumber: "PDF"
  },
  {
    id: "NNC-029",
    kolom1: "90020339g9",
    kolom2: "90020339g9",
    kolom3: "90020339g9",
    jawaban: "a",
    sumber: "PDF"
  },
  {
    id: "NNC-030",
    kolom1: "M.H. Suryalaya",
    kolom2: "M.H. Suryalaya",
    kolom3: "M.H. Suryalaya",
    jawaban: "a",
    sumber: "PDF"
  },

  // === SOAL GENERATE — pola sama dengan PDF ===
  {
    id: "NNC-031",
    kolom1: "4829103756",
    kolom2: "4829103756",
    kolom3: "4829103756",
    jawaban: "a",
    sumber: "generate"
  },
  {
    id: "NNC-032",
    kolom1: "Bagas Firmansyah",
    kolom2: "Bagas Firmansyah",
    kolom3: "Bagas Firmansyah",
    jawaban: "a",
    sumber: "generate"
  },
  {
    id: "NNC-033",
    kolom1: "7X3KP9QA2",
    kolom2: "7X3KP9QA2",
    kolom3: "7X3KP9QA2",
    jawaban: "a",
    sumber: "generate"
  },
  {
    id: "NNC-034",
    kolom1: "38471029465",
    kolom2: "38471029465",
    kolom3: "38471029466",
    jawaban: "b",
    sumber: "generate"
  },
  {
    id: "NNC-035",
    kolom1: "Prasetyo Widjaja",
    kolom2: "Prasetyo Widjaja",
    kolom3: "Prasetyo Widjaya",
    jawaban: "b",
    sumber: "generate"
  },
  {
    id: "NNC-036",
    kolom1: "BX7291KLM4",
    kolom2: "BX7291KLM4",
    kolom3: "BX7291KIM4",
    jawaban: "b",
    sumber: "generate"
  },
  {
    id: "NNC-037",
    kolom1: "9182736455",
    kolom2: "9182736456",
    kolom3: "9182736455",
    jawaban: "c",
    sumber: "generate"
  },
  {
    id: "NNC-038",
    kolom1: "Trisnawati Budiman",
    kolom2: "Trisnawate Budiman",
    kolom3: "Trisnawati Budiman",
    jawaban: "c",
    sumber: "generate"
  },
  {
    id: "NNC-039",
    kolom1: "K4M8R2T9N1",
    kolom2: "K4N8R2T9N1",
    kolom3: "K4M8R2T9N1",
    jawaban: "c",
    sumber: "generate"
  },
  {
    id: "NNC-040",
    kolom1: "7361928475",
    kolom2: "7361928574",
    kolom3: "7361928574",
    jawaban: "d",
    sumber: "generate"
  },
  {
    id: "NNC-041",
    kolom1: "Hendriawan Saputra",
    kolom2: "Hendriawan Saputro",
    kolom3: "Hendriawan Saputro",
    jawaban: "d",
    sumber: "generate"
  },
  {
    id: "NNC-042",
    kolom1: "Z9P3LM8KQ2",
    kolom2: "Z9P3LM8KO2",
    kolom3: "Z9P3LM8KO2",
    jawaban: "d",
    sumber: "generate"
  },
  {
    id: "NNC-043",
    kolom1: "5647382910",
    kolom2: "5647382901",
    kolom3: "5647382900",
    jawaban: "e",
    sumber: "generate"
  },
  {
    id: "NNC-044",
    kolom1: "Nurhayati Rahayu",
    kolom2: "Nurhayati Rahayu",
    kolom3: "Nurhayate Rahayu",
    jawaban: "b",
    sumber: "generate"
  },
  {
    id: "NNC-045",
    kolom1: "T8B4N2P6R1",
    kolom2: "T8B4N2P6R2",
    kolom3: "T8B4N2P6R3",
    jawaban: "e",
    sumber: "generate"
  },
  {
    id: "NNC-046",
    kolom1: "Reza Maulana Akbar",
    kolom2: "Reza Maulana Akbar",
    kolom3: "Reza Maulana Akbar",
    jawaban: "a",
    sumber: "generate"
  },
  {
    id: "NNC-047",
    kolom1: "19284756302",
    kolom2: "19284756302",
    kolom3: "19284756302",
    jawaban: "a",
    sumber: "generate"
  },
  {
    id: "NNC-048",
    kolom1: "A4C8E2G6I0",
    kolom2: "A4C8E2G6I0",
    kolom3: "A4C8E2G6I9",
    jawaban: "b",
    sumber: "generate"
  },
  {
    id: "NNC-049",
    kolom1: "Fadhilah Khoirunnisa",
    kolom2: "Fadhilah Khoirunnissa",
    kolom3: "Fadhilah Khoirunnisa",
    jawaban: "c",
    sumber: "generate"
  },
  {
    id: "NNC-050",
    kolom1: "82736451920",
    kolom2: "82736451029",
    kolom3: "82736451029",
    jawaban: "d",
    sumber: "generate"
  },
];

// ------------------------------------------------------------
// SUB-MODUL 2: MATRIKS ANGKA (Tes Angka 05)
// Format: kotak 3x3, baris/kolom pertama diketahui,
// user menentukan operasi (+, -, x, ÷) lalu isi kotak kosong.
// operasi: salah satu dari "+", "-", "x", "÷"
// grid: [baris0, baris1, baris2] masing-masing [kol0, kol1, kol2]
// null = kotak yang harus diisi user
// jawaban: array nilai yang harus diisi (urut kiri-kanan, atas-bawah)
// ------------------------------------------------------------

export const soalMatriksAngka = [
  // === DARI PDF TES ANGKA 05 (soal 21-40) ===
  {
    id: "MAT-001",
    operasi: "+",
    header_baris: [null, 7, 8],
    baris: [
      [4, 11, 12],
      [7, 14, 15],
    ],
    jawaban: [11, 12, 14, 15],
    sumber: "PDF"
  },
  {
    id: "MAT-002",
    operasi: "-",
    header_baris: [null, 3, 1],
    baris: [
      [18, 15, 17],
      [12, 9, 11],
    ],
    jawaban: [15, 17, 9, 11],
    sumber: "PDF"
  },
  {
    id: "MAT-003",
    operasi: "x",
    header_baris: [null, 3, 10],
    baris: [
      [3, 9, 30],
      [4, 12, 40],
    ],
    jawaban: [9, 30, 12, 40],
    sumber: "PDF"
  },
  {
    id: "MAT-004",
    operasi: "÷",
    header_baris: [null, 2, 2],
    baris: [
      [4, 2, 2],
      [12, 6, 6],
    ],
    jawaban: [2, 2, 6, 6],
    sumber: "PDF"
  },
  {
    id: "MAT-005",
    operasi: "x",
    header_baris: [null, 2, 4],
    baris: [
      [6, 12, 24],
      [12, 24, 48],
    ],
    jawaban: [12, 24, 24, 48],
    sumber: "PDF"
  },
  {
    id: "MAT-006",
    operasi: "+",
    header_baris: [null, 2, 4],
    baris: [
      [15, 17, 19],
      [8, 10, 12],
    ],
    jawaban: [17, 19, 10, 12],
    sumber: "PDF"
  },
  {
    id: "MAT-007",
    operasi: "÷",
    header_baris: [null, 2, 10],
    baris: [
      [40, 20, 4],
      [50, 25, 5],
    ],
    jawaban: [20, 4, 25, 5],
    sumber: "PDF"
  },
  {
    id: "MAT-008",
    operasi: "÷",
    header_baris: [null, 6, 3],
    baris: [
      [12, 2, 4],
      [36, 6, 12],
    ],
    jawaban: [2, 4, 6, 12],
    sumber: "PDF"
  },
  {
    id: "MAT-009",
    operasi: "-",
    header_baris: [null, 7, 16],
    baris: [
      [17, 10, 1],
      [19, 12, 3],
    ],
    jawaban: [10, 1, 12, 3],
    sumber: "PDF"
  },
  {
    id: "MAT-010",
    operasi: "x",
    header_baris: [null, 3, 5],
    baris: [
      [4, 12, 20],
      [9, 27, 45],
    ],
    jawaban: [12, 20, 27, 45],
    sumber: "PDF"
  },

  // === SOAL GENERATE — pola sama ===
  {
    id: "MAT-011",
    operasi: "+",
    header_baris: [null, 5, 3],
    baris: [
      [10, 15, 13],
      [20, 25, 23],
    ],
    jawaban: [15, 13, 25, 23],
    sumber: "generate"
  },
  {
    id: "MAT-012",
    operasi: "x",
    header_baris: [null, 4, 6],
    baris: [
      [3, 12, 18],
      [5, 20, 30],
    ],
    jawaban: [12, 18, 20, 30],
    sumber: "generate"
  },
  {
    id: "MAT-013",
    operasi: "-",
    header_baris: [null, 8, 5],
    baris: [
      [20, 12, 15],
      [30, 22, 25],
    ],
    jawaban: [12, 15, 22, 25],
    sumber: "generate"
  },
  {
    id: "MAT-014",
    operasi: "÷",
    header_baris: [null, 3, 4],
    baris: [
      [24, 8, 6],
      [36, 12, 9],
    ],
    jawaban: [8, 6, 12, 9],
    sumber: "generate"
  },
  {
    id: "MAT-015",
    operasi: "+",
    header_baris: [null, 9, 7],
    baris: [
      [11, 20, 18],
      [14, 23, 21],
    ],
    jawaban: [20, 18, 23, 21],
    sumber: "generate"
  },
  {
    id: "MAT-016",
    operasi: "x",
    header_baris: [null, 5, 8],
    baris: [
      [7, 35, 56],
      [9, 45, 72],
    ],
    jawaban: [35, 56, 45, 72],
    sumber: "generate"
  },
  {
    id: "MAT-017",
    operasi: "÷",
    header_baris: [null, 6, 9],
    baris: [
      [54, 9, 6],
      [72, 12, 8],
    ],
    jawaban: [9, 6, 12, 8],
    sumber: "generate"
  },
  {
    id: "MAT-018",
    operasi: "-",
    header_baris: [null, 11, 6],
    baris: [
      [25, 14, 19],
      [40, 29, 34],
    ],
    jawaban: [14, 19, 29, 34],
    sumber: "generate"
  },
  {
    id: "MAT-019",
    operasi: "x",
    header_baris: [null, 7, 3],
    baris: [
      [8, 56, 24],
      [6, 42, 18],
    ],
    jawaban: [56, 24, 42, 18],
    sumber: "generate"
  },
  {
    id: "MAT-020",
    operasi: "+",
    header_baris: [null, 14, 9],
    baris: [
      [6, 20, 15],
      [13, 27, 22],
    ],
    jawaban: [20, 15, 27, 22],
    sumber: "generate"
  },
];

// ------------------------------------------------------------
// SUB-MODUL 3: GAMBAR (banding dua gambar sama/beda)
// Format: dua gambar ditampilkan berdampingan, user menandai
// SAMA (jika identik) atau BEDA (jika ada perbedaan).
// Semua gambar ORISINAL buatan sendiri (bukan dari file manapun) —
// dibuat terinspirasi konsep tes visual sama/beda, dengan jawaban
// yang benar "by construction" (pasangan SAMA pakai kode SVG yang
// betul-betul identik, pasangan BEDA sengaja diberi 1 perbedaan
// nyata: bentuk, rotasi, jumlah elemen, atau posisi).
// ------------------------------------------------------------

export const soalGambar = [
  {
    id: 'GBR-001',
    gambarA: svgWrap(`<rect x="37" y="40" width="26" height="20" fill="#3B82F6" stroke="#1D4ED8" stroke-width="2"/>`),
    gambarB: svgWrap(`<rect x="37" y="40" width="26" height="20" fill="#3B82F6" stroke="#1D4ED8" stroke-width="2"/>`),
    jawaban: 'sama',
  },
  {
    id: 'GBR-002',
    gambarA: svgWrap(`<rect x="37" y="40" width="26" height="20" fill="#3B82F6" stroke="#1D4ED8" stroke-width="2"/>`),
    gambarB: svgWrap(`<polygon points="50,30 70,50 50,70 30,50" fill="#3B82F6" stroke="#1D4ED8" stroke-width="2"/>`),
    jawaban: 'beda',
  },
  {
    id: 'GBR-003',
    gambarA: svgWrap(`<rect x="34" y="34" width="32" height="32" fill="none" stroke="#10B981" stroke-width="2.5"/>`),
    gambarB: svgWrap(`<rect x="34" y="34" width="32" height="32" fill="none" stroke="#10B981" stroke-width="2.5"/>`),
    jawaban: 'sama',
  },
  {
    id: 'GBR-004',
    gambarA: svgWrap(`<rect x="34" y="34" width="32" height="32" fill="none" stroke="#10B981" stroke-width="2.5"/>`),
    gambarB: svgWrap(`<polygon points="35,70 35,32 68,50" fill="none" stroke="#10B981" stroke-width="2.5"/>`),
    jawaban: 'beda',
  },
  {
    id: 'GBR-005',
    gambarA: svgWrap(`<rect x="30" y="30" width="40" height="40" fill="none" stroke="#374151" stroke-width="2"/><line x1="30" y1="30" x2="70" y2="70" stroke="#374151" stroke-width="2"/>`),
    gambarB: svgWrap(`<rect x="30" y="30" width="40" height="40" fill="none" stroke="#374151" stroke-width="2"/><line x1="30" y1="30" x2="70" y2="70" stroke="#374151" stroke-width="2"/>`),
    jawaban: 'sama',
  },
  {
    id: 'GBR-006',
    gambarA: svgWrap(`<rect x="30" y="30" width="40" height="40" fill="none" stroke="#374151" stroke-width="2"/><line x1="30" y1="30" x2="70" y2="70" stroke="#374151" stroke-width="2"/>`),
    gambarB: svgWrap(`<rect x="30" y="30" width="40" height="40" fill="none" stroke="#374151" stroke-width="2"/><line x1="70" y1="30" x2="30" y2="70" stroke="#374151" stroke-width="2"/>`),
    jawaban: 'beda',
  },
  {
    id: 'GBR-007',
    gambarA: svgWrap(`<polygon points="50.0,28.0 70.9,43.2 62.9,67.8 37.1,67.8 29.1,43.2" fill="none" stroke="#8B5CF6" stroke-width="2.5"/>`),
    gambarB: svgWrap(`<polygon points="50.0,28.0 70.9,43.2 62.9,67.8 37.1,67.8 29.1,43.2" fill="none" stroke="#8B5CF6" stroke-width="2.5"/>`),
    jawaban: 'sama',
  },
  {
    id: 'GBR-008',
    gambarA: svgWrap(`<polygon points="50.0,28.0 70.9,43.2 62.9,67.8 37.1,67.8 29.1,43.2" fill="none" stroke="#8B5CF6" stroke-width="2.5"/>`),
    gambarB: svgWrap(`<polygon points="50.0,28.0 69.1,39.0 69.1,61.0 50.0,72.0 30.9,61.0 30.9,39.0" fill="none" stroke="#8B5CF6" stroke-width="2.5"/>`),
    jawaban: 'beda',
  },
  {
    id: 'GBR-009',
    gambarA: svgWrap(`<circle cx="50" cy="50" r="22" fill="none" stroke="#F59E0B" stroke-width="2"/><circle cx="50" cy="50" r="14" fill="none" stroke="#F59E0B" stroke-width="2"/>`),
    gambarB: svgWrap(`<circle cx="50" cy="50" r="22" fill="none" stroke="#F59E0B" stroke-width="2"/><circle cx="50" cy="50" r="14" fill="none" stroke="#F59E0B" stroke-width="2"/>`),
    jawaban: 'sama',
  },
  {
    id: 'GBR-010',
    gambarA: svgWrap(`<circle cx="50" cy="50" r="22" fill="none" stroke="#F59E0B" stroke-width="2"/><circle cx="50" cy="50" r="14" fill="none" stroke="#F59E0B" stroke-width="2"/>`),
    gambarB: svgWrap(`<circle cx="50" cy="50" r="22" fill="none" stroke="#F59E0B" stroke-width="2"/><circle cx="50" cy="50" r="14" fill="none" stroke="#F59E0B" stroke-width="2"/><circle cx="50" cy="50" r="7" fill="none" stroke="#F59E0B" stroke-width="2"/>`),
    jawaban: 'beda',
  },
  {
    id: 'GBR-011',
    gambarA: svgWrap(`<path d="M40,30 h20 v10 h10 v20 h-10 v10 h-20 v-10 h-10 v-20 h10 z" fill="none" stroke="#EF4444" stroke-width="2.5"/>`),
    gambarB: svgWrap(`<path d="M40,30 h20 v10 h10 v20 h-10 v10 h-20 v-10 h-10 v-20 h10 z" fill="none" stroke="#EF4444" stroke-width="2.5"/>`),
    jawaban: 'sama',
  },
  {
    id: 'GBR-012',
    gambarA: svgWrap(`<path d="M40,30 h20 v10 h10 v20 h-10 v10 h-20 v-10 h-10 v-20 h10 z" fill="none" stroke="#EF4444" stroke-width="2.5"/>`),
    gambarB: svgWrap(`<path d="M35,30 h30 l5,5 v30 l-5,5 h-30 l-5,-5 v-30 z" fill="none" stroke="#EF4444" stroke-width="2.5"/>`),
    jawaban: 'beda',
  },
  {
    id: 'GBR-013',
    gambarA: svgWrap(`<rect x="30" y="30" width="40" height="40" fill="none" stroke="#0F766E" stroke-width="2"/><line x1="30" y1="30" x2="70" y2="70" stroke="#0F766E" stroke-width="2"/><line x1="70" y1="30" x2="30" y2="70" stroke="#0F766E" stroke-width="2"/>`),
    gambarB: svgWrap(`<rect x="30" y="30" width="40" height="40" fill="none" stroke="#0F766E" stroke-width="2"/><line x1="30" y1="30" x2="70" y2="70" stroke="#0F766E" stroke-width="2"/><line x1="70" y1="30" x2="30" y2="70" stroke="#0F766E" stroke-width="2"/>`),
    jawaban: 'sama',
  },
  {
    id: 'GBR-014',
    gambarA: svgWrap(`<rect x="30" y="30" width="40" height="40" fill="none" stroke="#0F766E" stroke-width="2"/><line x1="30" y1="30" x2="70" y2="70" stroke="#0F766E" stroke-width="2"/><line x1="70" y1="30" x2="30" y2="70" stroke="#0F766E" stroke-width="2"/>`),
    gambarB: svgWrap(`<rect x="30" y="30" width="40" height="40" fill="none" stroke="#0F766E" stroke-width="2"/><line x1="30" y1="30" x2="70" y2="70" stroke="#0F766E" stroke-width="2"/>`),
    jawaban: 'beda',
  },
  {
    id: 'GBR-015',
    gambarA: svgWrap(`<polygon points="50.0,28.0 55.3,42.7 70.9,43.2 58.6,52.8 62.9,67.8 50.0,59.0 37.1,67.8 41.4,52.8 29.1,43.2 44.7,42.7" fill="#3B82F6" stroke="#1D4ED8" stroke-width="1.5"/>`),
    gambarB: svgWrap(`<polygon points="50.0,28.0 55.3,42.7 70.9,43.2 58.6,52.8 62.9,67.8 50.0,59.0 37.1,67.8 41.4,52.8 29.1,43.2 44.7,42.7" fill="#3B82F6" stroke="#1D4ED8" stroke-width="1.5"/>`),
    jawaban: 'sama',
  },
  {
    id: 'GBR-016',
    gambarA: svgWrap(`<polygon points="50.0,28.0 55.3,42.7 70.9,43.2 58.6,52.8 62.9,67.8 50.0,59.0 37.1,67.8 41.4,52.8 29.1,43.2 44.7,42.7" fill="#3B82F6" stroke="#1D4ED8" stroke-width="1.5"/>`),
    gambarB: svgWrap(`<polygon points="50.0,28.0 54.5,42.2 69.1,39.0 59.0,50.0 69.1,61.0 54.5,57.8 50.0,72.0 45.5,57.8 30.9,61.0 41.0,50.0 30.9,39.0 45.5,42.2" fill="#3B82F6" stroke="#1D4ED8" stroke-width="1.5"/>`),
    jawaban: 'beda',
  },
  {
    id: 'GBR-017',
    gambarA: svgWrap(`<polygon points="30,42 55,42 55,32 72,50 55,68 55,58 30,58" fill="#10B981" stroke="#047857" stroke-width="1.5"/>`),
    gambarB: svgWrap(`<polygon points="30,42 55,42 55,32 72,50 55,68 55,58 30,58" fill="#10B981" stroke="#047857" stroke-width="1.5"/>`),
    jawaban: 'sama',
  },
  {
    id: 'GBR-018',
    gambarA: svgWrap(`<polygon points="30,42 55,42 55,32 72,50 55,68 55,58 30,58" fill="#10B981" stroke="#047857" stroke-width="1.5"/>`),
    gambarB: svgWrap(`<polygon points="70,42 45,42 45,32 28,50 45,68 45,58 70,58" fill="#10B981" stroke="#047857" stroke-width="1.5"/>`),
    jawaban: 'beda',
  },
  {
    id: 'GBR-019',
    gambarA: svgWrap(`<circle cx="34.4" cy="34.4" r="3" fill="#8B5CF6"/><circle cx="34.4" cy="56" r="3" fill="#8B5CF6"/><circle cx="34.4" cy="77.6" r="3" fill="#8B5CF6"/><circle cx="56" cy="34.4" r="3" fill="#8B5CF6"/><circle cx="56" cy="56" r="3" fill="#8B5CF6"/><circle cx="56" cy="77.6" r="3" fill="#8B5CF6"/><circle cx="77.6" cy="34.4" r="3" fill="#8B5CF6"/><circle cx="77.6" cy="56" r="3" fill="#8B5CF6"/><circle cx="77.6" cy="77.6" r="3" fill="#8B5CF6"/>`),
    gambarB: svgWrap(`<circle cx="34.4" cy="34.4" r="3" fill="#8B5CF6"/><circle cx="34.4" cy="56" r="3" fill="#8B5CF6"/><circle cx="34.4" cy="77.6" r="3" fill="#8B5CF6"/><circle cx="56" cy="34.4" r="3" fill="#8B5CF6"/><circle cx="56" cy="56" r="3" fill="#8B5CF6"/><circle cx="56" cy="77.6" r="3" fill="#8B5CF6"/><circle cx="77.6" cy="34.4" r="3" fill="#8B5CF6"/><circle cx="77.6" cy="56" r="3" fill="#8B5CF6"/><circle cx="77.6" cy="77.6" r="3" fill="#8B5CF6"/>`),
    jawaban: 'sama',
  },
  {
    id: 'GBR-020',
    gambarA: svgWrap(`<circle cx="34.4" cy="34.4" r="3" fill="#8B5CF6"/><circle cx="34.4" cy="56" r="3" fill="#8B5CF6"/><circle cx="34.4" cy="77.6" r="3" fill="#8B5CF6"/><circle cx="56" cy="34.4" r="3" fill="#8B5CF6"/><circle cx="56" cy="56" r="3" fill="#8B5CF6"/><circle cx="56" cy="77.6" r="3" fill="#8B5CF6"/><circle cx="77.6" cy="34.4" r="3" fill="#8B5CF6"/><circle cx="77.6" cy="56" r="3" fill="#8B5CF6"/><circle cx="77.6" cy="77.6" r="3" fill="#8B5CF6"/>`),
    gambarB: svgWrap(`<circle cx="34.4" cy="34.4" r="3" fill="#8B5CF6"/><circle cx="34.4" cy="56" r="3" fill="#8B5CF6"/><circle cx="34.4" cy="77.6" r="3" fill="#8B5CF6"/><circle cx="56" cy="34.4" r="3" fill="#8B5CF6"/><circle cx="56" cy="56" r="3" fill="#8B5CF6"/><circle cx="56" cy="77.6" r="3" fill="#8B5CF6"/><circle cx="77.6" cy="34.4" r="3" fill="#8B5CF6"/><circle cx="77.6" cy="56" r="3" fill="#8B5CF6"/>`),
    jawaban: 'beda',
  },
  {
    id: 'GBR-021',
    gambarA: svgWrap(`<polyline points="25,60 37,35 49,60 61,35 73,60" fill="none" stroke="#F59E0B" stroke-width="2.5"/>`),
    gambarB: svgWrap(`<polyline points="25,60 37,35 49,60 61,35 73,60" fill="none" stroke="#F59E0B" stroke-width="2.5"/>`),
    jawaban: 'sama',
  },
  {
    id: 'GBR-022',
    gambarA: svgWrap(`<polyline points="25,60 37,35 49,60 61,35 73,60" fill="none" stroke="#F59E0B" stroke-width="2.5"/>`),
    gambarB: svgWrap(`<polyline points="25,55 37,35 49,55 61,20 73,55" fill="none" stroke="#F59E0B" stroke-width="2.5"/>`),
    jawaban: 'beda',
  },
  {
    id: 'GBR-023',
    gambarA: svgWrap(`<polygon points="50,25 75,45 75,75 25,75 25,45" fill="none" stroke="#B91C1C" stroke-width="2.5"/>`),
    gambarB: svgWrap(`<polygon points="50,25 75,45 75,75 25,75 25,45" fill="none" stroke="#B91C1C" stroke-width="2.5"/>`),
    jawaban: 'sama',
  },
  {
    id: 'GBR-024',
    gambarA: svgWrap(`<polygon points="50,25 75,45 75,75 25,75 25,45" fill="none" stroke="#B91C1C" stroke-width="2.5"/>`),
    gambarB: svgWrap(`<polygon points="58,25 75,45 75,75 25,75 25,45" fill="none" stroke="#B91C1C" stroke-width="2.5"/>`),
    jawaban: 'beda',
  },
  {
    id: 'GBR-025',
    gambarA: svgWrap(`<circle cx="42" cy="50" r="18" fill="none" stroke="#0EA5E9" stroke-width="2"/><circle cx="58" cy="50" r="18" fill="none" stroke="#0EA5E9" stroke-width="2"/>`),
    gambarB: svgWrap(`<circle cx="42" cy="50" r="18" fill="none" stroke="#0EA5E9" stroke-width="2"/><circle cx="58" cy="50" r="18" fill="none" stroke="#0EA5E9" stroke-width="2"/>`),
    jawaban: 'sama',
  },
  {
    id: 'GBR-026',
    gambarA: svgWrap(`<circle cx="42" cy="50" r="18" fill="none" stroke="#0EA5E9" stroke-width="2"/><circle cx="58" cy="50" r="18" fill="none" stroke="#0EA5E9" stroke-width="2"/>`),
    gambarB: svgWrap(`<circle cx="38" cy="50" r="18" fill="none" stroke="#0EA5E9" stroke-width="2"/><circle cx="62" cy="50" r="18" fill="none" stroke="#0EA5E9" stroke-width="2"/>`),
    jawaban: 'beda',
  },
  {
    id: 'GBR-027',
    gambarA: svgWrap(`<path d="M30,32 h40 v10 h-15 v26 h-10 v-26 h-15 z" fill="#374151"/>`),
    gambarB: svgWrap(`<path d="M30,32 h40 v10 h-15 v26 h-10 v-26 h-15 z" fill="#374151"/>`),
    jawaban: 'sama',
  },
  {
    id: 'GBR-028',
    gambarA: svgWrap(`<path d="M30,32 h40 v10 h-15 v26 h-10 v-26 h-15 z" fill="#374151"/>`),
    gambarB: svgWrap(`<path d="M30,32 h40 v10 h-15 v26 h-10 v-26 h-15 z" fill="#374151" transform="rotate(180 50 50)"/>`),
    jawaban: 'beda',
  },
  {
    id: 'GBR-029',
    gambarA: svgWrap(`<rect x="30" y="30" width="20" height="20" fill="#111827"/><rect x="50" y="50" width="20" height="20" fill="#111827"/><rect x="50" y="30" width="20" height="20" fill="none" stroke="#111827" stroke-width="1.5"/><rect x="30" y="50" width="20" height="20" fill="none" stroke="#111827" stroke-width="1.5"/>`),
    gambarB: svgWrap(`<rect x="30" y="30" width="20" height="20" fill="#111827"/><rect x="50" y="50" width="20" height="20" fill="#111827"/><rect x="50" y="30" width="20" height="20" fill="none" stroke="#111827" stroke-width="1.5"/><rect x="30" y="50" width="20" height="20" fill="none" stroke="#111827" stroke-width="1.5"/>`),
    jawaban: 'sama',
  },
  {
    id: 'GBR-030',
    gambarA: svgWrap(`<rect x="30" y="30" width="20" height="20" fill="#111827"/><rect x="50" y="50" width="20" height="20" fill="#111827"/><rect x="50" y="30" width="20" height="20" fill="none" stroke="#111827" stroke-width="1.5"/><rect x="30" y="50" width="20" height="20" fill="none" stroke="#111827" stroke-width="1.5"/>`),
    gambarB: svgWrap(`<rect x="50" y="30" width="20" height="20" fill="#111827"/><rect x="30" y="50" width="20" height="20" fill="#111827"/><rect x="30" y="30" width="20" height="20" fill="none" stroke="#111827" stroke-width="1.5"/><rect x="50" y="50" width="20" height="20" fill="none" stroke="#111827" stroke-width="1.5"/>`),
    jawaban: 'beda',
  },
];

// ------------------------------------------------------------
// SUB-MODUL 4: TEKS (banding dua rangkaian teks sama/beda)
// Format: dua baris teks/kode ditampilkan berdampingan, user
// menandai SAMA (jika identik persis) atau BEDA (jika ada
// perbedaan sekecil apapun — huruf, angka, ejaan, tanda baca).
// Sumber: soal "Tes Kemampuan Kecerdasan" (30 pasang), setiap
// pasangan sudah diverifikasi manual karakter-per-karakter dari
// dokumen sumber sebelum dimasukkan.
// ------------------------------------------------------------

export const soalTeks = [
  { id: 'TEK-001', teksA: 'ADBBFGHJILHOP', teksB: 'ADBBFGHIJLHOP', jawaban: 'beda' },
  { id: 'TEK-002', teksA: 'C77DB6FGH58KL', teksB: 'C77DB6FGH58KL', jawaban: 'sama' },
  { id: 'TEK-003', teksA: 'PQRSTSPNABSAJ', teksB: 'PQRSTSPANBSAJ', jawaban: 'beda' },
  { id: 'TEK-004', teksA: 'Kewarganegaraan', teksB: 'Kewarga-negaraan', jawaban: 'beda' },
  { id: 'TEK-005', teksA: 'William Sturgen', teksB: 'William Sturgen', jawaban: 'sama' },
  { id: 'TEK-006', teksA: 'Benyamin Franklin', teksB: 'Benjamin Franklin', jawaban: 'beda' },
  { id: 'TEK-007', teksA: 'Drs. Soerjono Soeeb', teksB: 'Drs. Soerjono Soeeb', jawaban: 'sama' },
  { id: 'TEK-008', teksA: 'The University Of Indonesia', teksB: 'The University Of Indonesia', jawaban: 'sama' },
  { id: 'TEK-009', teksA: 'P.O.BOX. 7789, Jakarta 12059', teksB: 'P.O.BOX. 7789, Jakarta 10259', jawaban: 'beda' },
  { id: 'TEK-010', teksA: 'He said to me, "What are you doing ?"', teksB: 'He said to me, What are you doing ?', jawaban: 'beda' },
  { id: 'TEK-011', teksA: 'H.,N., & Mager, S.K.,', teksB: 'H.,N., & Mager, S.K.,', jawaban: 'sama' },
  { id: 'TEK-012', teksA: '421. +-, 744.*-071.', teksB: '421.+-, 744.*-071.', jawaban: 'beda' },
  { id: 'TEK-013', teksA: '920!*74410!*.*01', teksB: '920*! 74410*!.*01', jawaban: 'beda' },
  { id: 'TEK-014', teksA: '421001099178338', teksB: '421001099718338', jawaban: 'beda' },
  { id: 'TEK-015', teksA: '699655454854040', teksB: '699655454854040', jawaban: 'sama' },
  { id: 'TEK-016', teksA: 'On hundred and thirty-four', teksB: 'On hundred and thirty-four', jawaban: 'sama' },
  { id: 'TEK-017', teksA: 'Three Milliard', teksB: 'Tree Milliard', jawaban: 'beda' },
  { id: 'TEK-018', teksA: 'Bachelor Of Business Administration', teksB: 'Bachelor Of Busines Administration', jawaban: 'beda' },
  { id: 'TEK-019', teksA: 'The President Theatre', teksB: 'The President Theatre', jawaban: 'sama' },
  { id: 'TEK-020', teksA: 'Cemical Engineering', teksB: 'Cemical Enginering', jawaban: 'beda' },
  { id: 'TEK-021', teksA: 'Soerabaya, 05 July 1985', teksB: 'Soerabaya, 05 July 1985', jawaban: 'sama' },
  { id: 'TEK-022', teksA: 'Jogjakarta, Januari 76', teksB: 'Jogjakarta, Januari 76', jawaban: 'sama' },
  { id: 'TEK-023', teksA: 'Ms. Willie Widyastuti', teksB: 'Ms. Willie Widiastuti', jawaban: 'beda' },
  { id: 'TEK-024', teksA: 'Trans Warld Airlines', teksB: 'Trans World Airlines', jawaban: 'beda' },
  { id: 'TEK-025', teksA: 'Bulgarska Telegrafitscheka', teksB: 'Bulgarska Telegrafitsheka', jawaban: 'beda' },
  { id: 'TEK-026', teksA: 'Mengapa engkau Begitu ?"', teksB: 'Mengapa engkau begitu ?', jawaban: 'beda' },
  { id: 'TEK-027', teksA: '1900200120022003', teksB: '1900200120022003', jawaban: 'sama' },
  { id: 'TEK-028', teksA: 'Nyong Celebes Sumpah Pemoeda', teksB: 'Nyong celebes sumpah Pemuda', jawaban: 'beda' },
  { id: 'TEK-029', teksA: 'Layoe karma panas', teksB: 'Layoe karna panas', jawaban: 'beda' },
  { id: 'TEK-030', teksA: 'Lintas Djayapura dan Djakarta', teksB: 'Lintas Djayapura dan Djakarta', jawaban: 'sama' },
];

// ------------------------------------------------------------
// HELPER FUNCTIONS
// ------------------------------------------------------------

export function getRandomSoalNNC2(jumlah = 30) {
  const shuffled = [...soalNNC2].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, jumlah);
}

export function getRandomSoalMatriks(jumlah = 10) {
  const shuffled = [...soalMatriksAngka].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, jumlah);
}

export function getRandomSoalGambar(jumlah = 20) {
  const shuffled = [...soalGambar].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, jumlah);
}

// Mode "Campuran" — gabungan NNC-2 + Gambar + Teks, dipakai sebagai komposisi
// resmi Tryout (supaya soal Gambar & Teks yang baru ikut kepakai, bukan cuma
// latihan mandiri). Tiap soal ditandai `jenis` supaya modul tahu cara render
// & menilai jawabannya per item (beda dari mode tunggal yang seragam).
export function getRandomSoalCampuran({ jumlahNNC2 = 15, jumlahGambar = 10, jumlahTeks = 10, jumlahHitungHuruf = 0 } = {}) {
  const nnc2 = getRandomSoalNNC2(jumlahNNC2).map(s => ({ ...s, jenis: 'nnc2' }));
  const gambar = getRandomSoalGambar(jumlahGambar).map(s => ({ ...s, jenis: 'gambar' }));
  const teksShuffled = [...soalTeks].sort(() => Math.random() - 0.5).slice(0, jumlahTeks).map(s => ({ ...s, jenis: 'teks' }));
  const hitungHuruf = jumlahHitungHuruf > 0
    ? getSoalHitungI(jumlahHitungHuruf).map(s => ({ ...s, jenis: 'hitungHuruf' }))
    : [];
  return [...nnc2, ...gambar, ...teksShuffled, ...hitungHuruf];
}

export function hitungSkorNNC2(jawaban, kunciJawaban) {
  let benar = 0, salah = 0;
  jawaban.forEach((j, i) => {
    if (j === kunciJawaban[i]) benar++;
    else if (j !== null) salah++;
  });
  return { benar, salah, kosong: jawaban.filter(j => j === null).length };
}

export function hitungSkorGambar(jawaban, kunciJawaban) {
  let benar = 0, salah = 0;
  jawaban.forEach((j, i) => {
    if (j === kunciJawaban[i]) benar++;
    else if (j !== null) salah++;
  });
  return { benar, salah, kosong: jawaban.filter(j => j === null).length };
}

export function getRandomSoalTeks(jumlah = 20) {
  const shuffled = [...soalTeks].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, jumlah);
}

export function hitungSkorTeks(jawaban, kunciJawaban) {
  let benar = 0, salah = 0;
  jawaban.forEach((j, i) => {
    if (j === kunciJawaban[i]) benar++;
    else if (j !== null) salah++;
  });
  return { benar, salah, kosong: jawaban.filter(j => j === null).length };
}

// ------------------------------------------------------------
// SUB-MODUL: HITUNG HURUF "i"
// Format: deretan angka acak dengan huruf "i" diselipkan di posisi acak.
// Peserta menghitung berapa kali huruf "i" muncul pada satu baris, dalam
// batas waktu. Soal DI-GENERATE ON-THE-FLY (bukan bank statis) — supaya
// variasinya praktis tidak terbatas dan tidak bisa dihafal urutannya,
// mirip cara Kraepelin men-generate kolom angkanya sendiri.
// ------------------------------------------------------------
const PANJANG_DERET_HITUNGI = 24; // total karakter per baris (digit + huruf i)
const MAKS_JUMLAH_I = 6;          // huruf "i" per baris: acak 0..6

function buatSatuSoalHitungI(id) {
  const jumlahI = Math.floor(Math.random() * (MAKS_JUMLAH_I + 1));
  const panjangAngka = PANJANG_DERET_HITUNGI - jumlahI;
  const arr = Array.from({ length: panjangAngka }, () => String(Math.floor(Math.random() * 10)));
  for (let k = 0; k < jumlahI; k++) {
    const pos = Math.floor(Math.random() * (arr.length + 1));
    arr.splice(pos, 0, 'i');
  }
  return { id, deret: arr.join(''), jumlahI };
}

export function getSoalHitungI(jumlah = 20) {
  return Array.from({ length: jumlah }, (_, i) => buatSatuSoalHitungI(`HTI-${Date.now()}-${i}`));
}

export function hitungSkorHitungI(jawaban, soalList) {
  let benar = 0, salah = 0;
  jawaban.forEach((j, i) => {
    if (j === null || j === undefined) return;
    if (j === soalList[i]?.jumlahI) benar++; else salah++;
  });
  return { benar, salah, kosong: jawaban.filter(j => j === null || j === undefined).length };
}

export const totalSoal = {
  NNC2: soalNNC2.length,
  matriksAngka: soalMatriksAngka.length,
  total: soalNNC2.length + soalMatriksAngka.length,
  dariPDF: soalNNC2.filter(s => s.sumber === "PDF").length + soalMatriksAngka.filter(s => s.sumber === "PDF").length,
  generate: soalNNC2.filter(s => s.sumber === "generate").length + soalMatriksAngka.filter(s => s.sumber === "generate").length,
}

// ===== SOAL TAMBAHAN BARU =====

// NNC-2 — tambahan soal baru (soal lama tetap dipertahankan)
soalNNC2.push(
  { id: "NNC-131", kolom1: "Bambang Susilo", kolom2: "Bambang Susilo", kolom3: "Bambang Susilo", jawaban: "a", sumber: "generate" },
  { id: "NNC-132", kolom1: "1661361", kolom2: "1661361", kolom3: "6161361", jawaban: "b", sumber: "generate" },
  { id: "NNC-133", kolom1: "9014008", kolom2: "9014001", kolom3: "9014008", jawaban: "c", sumber: "generate" },
  { id: "NNC-134", kolom1: "Hendla Gunawan", kolom2: "Hendra Gunawan", kolom3: "Hendra Gunawan", jawaban: "d", sumber: "generate" },
  { id: "NNC-135", kolom1: "6482969", kolom2: "6842969", kolom3: "6482919", jawaban: "e", sumber: "generate" },
  { id: "NNC-136", kolom1: "4358033", kolom2: "4358033", kolom3: "4358033", jawaban: "a", sumber: "generate" },
  { id: "NNC-137", kolom1: "Ratna Kumala", kolom2: "Ratna Kumala", kolom3: "Ratna Kuala", jawaban: "b", sumber: "generate" },
  { id: "NNC-138", kolom1: "2417205", kolom2: "2477205", kolom3: "2417205", jawaban: "c", sumber: "generate" },
  { id: "NNC-139", kolom1: "4991590", kolom2: "4901590", kolom3: "4901590", jawaban: "d", sumber: "generate" },
  { id: "NNC-140", kolom1: "Dewi Lestari", kolom2: "Dei Lestari", kolom3: "Dewi Lestori", jawaban: "e", sumber: "generate" },
  { id: "NNC-141", kolom1: "8185162", kolom2: "8185162", kolom3: "8185162", jawaban: "a", sumber: "generate" },
  { id: "NNC-142", kolom1: "6530300", kolom2: "6530300", kolom3: "5630300", jawaban: "b", sumber: "generate" },
  { id: "NNC-143", kolom1: "Bambang Susilo", kolom2: "Bambong Susilo", kolom3: "Bambang Susilo", jawaban: "c", sumber: "generate" },
  { id: "NNC-144", kolom1: "9554610", kolom2: "9554810", kolom3: "9554810", jawaban: "d", sumber: "generate" },
  { id: "NNC-145", kolom1: "1051880", kolom2: "9051880", kolom3: "1015880", jawaban: "e", sumber: "generate" },
  { id: "NNC-146", kolom1: "Wulandari Putri", kolom2: "Wulandari Putri", kolom3: "Wulandari Putri", jawaban: "a", sumber: "generate" },
  { id: "NNC-147", kolom1: "7240664", kolom2: "7240664", kolom3: "7248664", jawaban: "b", sumber: "generate" },
  { id: "NNC-148", kolom1: "0819556", kolom2: "0189556", kolom3: "0819556", jawaban: "c", sumber: "generate" },
  { id: "NNC-149", kolom1: "Fajar Nugraho", kolom2: "Fajar Nugroho", kolom3: "Fajar Nugroho", jawaban: "d", sumber: "generate" },
  { id: "NNC-150", kolom1: "4890320", kolom2: "8890320", kolom3: "4890230", jawaban: "e", sumber: "generate" },
  { id: "NNC-151", kolom1: "2908898", kolom2: "2908898", kolom3: "2908898", jawaban: "a", sumber: "generate" },
  { id: "NNC-152", kolom1: "Sutrisno Hadi", kolom2: "Sutrisno Hadi", kolom3: "Sotrisno Hadi", jawaban: "b", sumber: "generate" },
  { id: "NNC-153", kolom1: "8007148", kolom2: "8007141", kolom3: "8007148", jawaban: "c", sumber: "generate" },
  { id: "NNC-154", kolom1: "1114686", kolom2: "1141686", kolom3: "1141686", jawaban: "d", sumber: "generate" },
  { id: "NNC-155", kolom1: "Agus Setiawan", kolom2: "Agus Setiowan", kolom3: "Agus Sitiawan", jawaban: "e", sumber: "generate" },
  { id: "NNC-156", kolom1: "9637706", kolom2: "9637706", kolom3: "9637706", jawaban: "a", sumber: "generate" },
  { id: "NNC-157", kolom1: "2858271", kolom2: "2858271", kolom3: "2858217", jawaban: "b", sumber: "generate" },
  { id: "NNC-158", kolom1: "Teguh Prasetyo", kolom2: "Teguh Prazetyo", kolom3: "Teguh Prasetyo", jawaban: "c", sumber: "generate" },
  { id: "NNC-159", kolom1: "1207526", kolom2: "1807526", kolom3: "1807526", jawaban: "d", sumber: "generate" },
  { id: "NNC-160", kolom1: "9844265", kolom2: "1844265", kolom3: "9484265", jawaban: "e", sumber: "generate" },
  { id: "NNC-161", kolom1: "Agus Setiawan", kolom2: "Agus Setiawan", kolom3: "Agus Setiawan", jawaban: "a", sumber: "generate" },
  { id: "NNC-162", kolom1: "6383014", kolom2: "6383014", kolom3: "6383614", jawaban: "b", sumber: "generate" },
  { id: "NNC-163", kolom1: "9038238", kolom2: "9438238", kolom3: "9038238", jawaban: "c", sumber: "generate" },
  { id: "NNC-164", kolom1: "Hendra Gunawon", kolom2: "Hendra Gunawan", kolom3: "Hendra Gunawan", jawaban: "d", sumber: "generate" },
  { id: "NNC-165", kolom1: "0770195", kolom2: "0778195", kolom3: "0770159", jawaban: "e", sumber: "generate" },
  { id: "NNC-166", kolom1: "2876141", kolom2: "2876141", kolom3: "2876141", jawaban: "a", sumber: "generate" },
  { id: "NNC-167", kolom1: "Siti Aminah", kolom2: "Siti Aminah", kolom3: "Siti ominah", jawaban: "b", sumber: "generate" },
  { id: "NNC-168", kolom1: "6924994", kolom2: "6924914", kolom3: "6924994", jawaban: "c", sumber: "generate" },
  { id: "NNC-169", kolom1: "1569918", kolom2: "1569911", kolom3: "1569911", jawaban: "d", sumber: "generate" },
  { id: "NNC-170", kolom1: "Eko Prabowo", kolom2: "Eo Prabowo", kolom3: "Eka Prabowo", jawaban: "e", sumber: "generate" },
);

// TEKS — tambahan soal baru (soal lama tetap dipertahankan)
soalTeks.push(
  { id: "TEK-111", teksA: "Batalyon Infanteri", teksB: "Batalyon Infanteri", jawaban: "sama" },
  { id: "TEK-112", teksA: "Wawasan Nusantara", teksB: "Wawasan Nusantraa", jawaban: "beda" },
  { id: "TEK-113", teksA: "VXYFNJY6GYPLP", teksB: "VXYFNJY6GYPLP", jawaban: "sama" },
  { id: "TEK-114", teksA: "WPBSDRF3GGYU6", teksB: "WBSDRF3GGYU6", jawaban: "beda" },
  { id: "TEK-115", teksA: "Batalyon Infanteri", teksB: "Batalyon Infanteri", jawaban: "sama" },
  { id: "TEK-116", teksA: "Ketahanan Nasional", teksB: "Ketahanan Nsaional", jawaban: "beda" },
  { id: "TEK-117", teksA: "UF48XJXECQ3GA", teksB: "UF48XJXECQ3GA", jawaban: "sama" },
  { id: "TEK-118", teksA: "GVLCUG64UTD4U", teksB: "GVLCUG64UT4DU", jawaban: "beda" },
  { id: "TEK-119", teksA: "Komando Daerah", teksB: "Komando Daerah", jawaban: "sama" },
  { id: "TEK-120", teksA: "Komando Daerah", teksB: "Komando Dairah", jawaban: "beda" },
  { id: "TEK-121", teksA: "9RRU26N9HZ4NG", teksB: "9RRU26N9HZ4NG", jawaban: "sama" },
  { id: "TEK-122", teksA: "WJLRYY9BGVVL8", teksB: "WLJRYY9BGVVL8", jawaban: "beda" },
  { id: "TEK-123", teksA: "Wawasan Nusantara", teksB: "Wawasan Nusantara", jawaban: "sama" },
  { id: "TEK-124", teksA: "Wawasan Nusantara", teksB: "Wawasan uNsantara", jawaban: "beda" },
  { id: "TEK-125", teksA: "JQ6E6CZ57276E", teksB: "JQ6E6CZ57276E", jawaban: "sama" },
  { id: "TEK-126", teksA: "L99W3RZ39FGAT", teksB: "L99W3R39FGAT", jawaban: "beda" },
  { id: "TEK-127", teksA: "Batalyon Infanteri", teksB: "Batalyon Infanteri", jawaban: "sama" },
  { id: "TEK-128", teksA: "Kesatuan Lapangan", teksB: "Kesatuan Lapnagan", jawaban: "beda" },
  { id: "TEK-129", teksA: "YK9WVWZNQMFCC", teksB: "YK9WVWZNQMFCC", jawaban: "sama" },
  { id: "TEK-130", teksA: "D2TNYPAFP9VE7", teksB: "D2TNYPAFP9EV7", jawaban: "beda" },
  { id: "TEK-131", teksA: "Ketahanan Nasional", teksB: "Ketahanan Nasional", jawaban: "sama" },
  { id: "TEK-132", teksA: "Wawasan Nusantara", teksB: "Wowasan Nusantara", jawaban: "beda" },
  { id: "TEK-133", teksA: "4DJQ48ZVZKLM5", teksB: "4DJQ48ZVZKLM5", jawaban: "sama" },
  { id: "TEK-134", teksA: "TV9GF3LAZDZTS", teksB: "T9VGF3LAZDZTS", jawaban: "beda" },
  { id: "TEK-135", teksA: "Patroli Perbatasan", teksB: "Patroli Perbatasan", jawaban: "sama" },
  { id: "TEK-136", teksA: "Pertahanan Negara", teksB: "Pertahanan eNgara", jawaban: "beda" },
  { id: "TEK-137", teksA: "666YN275326FL", teksB: "666YN275326FL", jawaban: "sama" },
  { id: "TEK-138", teksA: "3VW6NTFZDNFVB", teksB: "3W6NTFZDNFVB", jawaban: "beda" },
  { id: "TEK-139", teksA: "Batalyon Infanteri", teksB: "Batalyon Infanteri", jawaban: "sama" },
  { id: "TEK-140", teksA: "Kesatuan Lapangan", teksB: "eKsatuan Lapangan", jawaban: "beda" },
  { id: "TEK-141", teksA: "HWBNS43QL87KQ", teksB: "HWBNS43QL87KQ", jawaban: "sama" },
  { id: "TEK-142", teksA: "PHSU46MHZS36J", teksB: "PHUS46MHZS36J", jawaban: "beda" },
  { id: "TEK-143", teksA: "Komando Daerah", teksB: "Komando Daerah", jawaban: "sama" },
  { id: "TEK-144", teksA: "Komando Daerah", teksB: "Komanda Daerah", jawaban: "beda" },
  { id: "TEK-145", teksA: "FZ3KXPPXHUR63", teksB: "FZ3KXPPXHUR63", jawaban: "sama" },
  { id: "TEK-146", teksA: "F9UTEVKPUS7LF", teksB: "F9UTEVKUPS7LF", jawaban: "beda" },
  { id: "TEK-147", teksA: "Kesatuan Lapangan", teksB: "Kesatuan Lapangan", jawaban: "sama" },
  { id: "TEK-148", teksA: "Ketahanan Nasional", teksB: "Ketahaann Nasional", jawaban: "beda" },
  { id: "TEK-149", teksA: "3YRLRHCZ7SVDT", teksB: "3YRLRHCZ7SVDT", jawaban: "sama" },
  { id: "TEK-150", teksA: "J7BDEG97YSL2R", teksB: "J7BDiG97YSL2R", jawaban: "beda" },
);
